import { render, staticRenderFns } from "./IssueElementUI.vue?vue&type=template&id=e6da2bae&"
import script from "./IssueElementUI.vue?vue&type=script&lang=js&"
export * from "./IssueElementUI.vue?vue&type=script&lang=js&"
import style0 from "./IssueElementUI.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports